import React from 'react';
import { connect } from 'react-redux'
import { fetchEvent, editEvent, deleteEvent, returnFromEditCreateEvent, clearEditState } from '../../actions'
import EventForm from './EventForm'
import { CREATOR } from '../helpers/AppConsts' 
import { hasNoEditEvent } from '../helpers/EventUtils'
import ReactGA from 'react-ga';
import { GA_TRACKING_EDIT_PAGE } from '../helpers/AppConsts'


class EventEdit extends React.Component {

  componentDidMount(){
    ReactGA.ga('send', 'pageview', GA_TRACKING_EDIT_PAGE);
    this.props.fetchEvent(this.props.match.params.eventId, this.props.match.params.event_organizer);
  }

  componentWillUnmount(){
    this.props.clearEditState();
  }

  onSubmit = (formValues) => {

    formValues.registered_players= ["placeholder"];
    formValues.event_id = this.props.edits.editEvent.event_id;
    formValues.event_organizer = this.props.edits.editEvent.event_organizer;
    formValues.event_img = this.props.edits.editEvent.event_img;
    formValues.event_results = this.props.edits.editEvent.event_results;
    formValues.event_date = this.props.edits.editEvent.event_date;

    this.props.editEvent(formValues)
  }
  
  onDelete = (formValues) => {
    this.props.deleteEvent( this.props.edits.editEvent.event_id, this.props.edits.editEvent.event_date);
  }

  onReturn = (formValues) => {
    this.props.returnFromEditCreateEvent();
  }

  renderEvent() {
    return  (
      <div className="content">
           <br/>
        {/* <div className="header">Event_ID:{this.props.edits.editEvent.event_id}</div> */}
          <button className="ui button negative" onClick={this.onDelete}>
            Delete
          </button>
          <button className="ui button positive" onClick={this.onReturn}>
            Return
          </button>
      </div>
    )
}

  renderLoadingDesc = () => {
    return (
      <div className="ui container">
        <h2>Edit Event</h2>
        Loading..          
      </div>
    );
  }

  renderEditForm = () => {
    return (
      <div className="ui container">
        <h2>Edit Event</h2>
        <div className="ui celled list">
        <EventForm 
            onSubmit={this.onSubmit} 
            isEditMode={true} 
            reinitialize={true} 
            initialValues={this.props.edits.editEvent} 
            /> 
            {this.renderEvent()}
        </div>
      </div>
    );   
  }

  render () { 
     return hasNoEditEvent(this.props.edits) ? this.renderLoadingDesc() : this.renderEditForm();
  }

};

const mapStateToProps = (state, ownProps) => {
  return {
    edits: state.edits,
    currentUserEmail: CREATOR
  };  
}

export default connect(mapStateToProps, {fetchEvent, editEvent, deleteEvent, clearEditState, returnFromEditCreateEvent})(EventEdit)
